import clsx from 'clsx';
import type { QuarterlyData } from './periods';
import { getForecastContext } from './periods';
import { useTableSettings } from './TableSettingsContext';
import { formatCurrency } from './CurrencyDisplay';
import { RowLabel, type RowHint } from './RowHint';

interface GrandTotalRowProps {
  label: string;
  hint?: RowHint | null;
  data: QuarterlyData;
  className?: string;
}

export function GrandTotalRow({ label, hint, data, className }: GrandTotalRowProps) {
  const { settings } = useTableSettings();
  const allQuarters = settings ? getForecastContext(settings).allQuarters : [];

  return (
    <tr className={clsx('border-t-2 border-gray-600', className)}>
      <td className="sticky left-0 z-10 bg-white px-3 py-2 text-sm font-bold text-gray-900 border-r border-b-2 border-gray-400">
        <RowLabel label={label} hint={hint} />
      </td>
      {allQuarters.map((q) => {
        const value = data[q] ?? 0;
        return (
          <td
            key={q}
            className={clsx(
              'px-3 py-2 text-right text-sm tabular-nums font-bold border-r border-b-2 border-gray-400',
              'bg-gray-100',
              value === 0 ? 'text-gray-400' : value < 0 ? 'text-red-600' : 'text-gray-900',
            )}
          >
            {value === 0 ? '-' : formatCurrency(value)}
          </td>
        );
      })}
    </tr>
  );
}
